"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const forms_1 = require("@rebass/forms");
const rebass_1 = require("rebass");
function default_1(_a) {
    var { label, value, onChange = () => { } } = _a, rest = __rest(_a, ["label", "value", "onChange"]);
    return (react_1.default.createElement("div", { className: "form-element" },
        react_1.default.createElement(rebass_1.Text, { fontWeight: 500, fontSize: 13 }, label),
        react_1.default.createElement(forms_1.Textarea, Object.assign({ value: value, onChange: onChange, mt: 2, maxWidth: "100%", padding: 15 }, rest, { css: {} }))));
}
exports.default = default_1;
//# sourceMappingURL=TextareaInput.js.map